import React, { Component } from 'react';
import ReactQuill from 'react-quill'; // ES6
import 'react-quill/dist/quill.snow.css'; // ES6
import { modules, formats } from './TextEditorToolbar';
import { Form } from 'formsy-semantic-ui-react';
import { singleLineText } from './RegexValidation';
import { withFormsy } from 'formsy-react';

class TextEditor extends Component {

    componentDidMount() {
        if (this.props.autoFocus && this.props.type === "textarea") {
            this.refs.bodyInput.focus();
        }
    }


    render() {
        setTimeout(
            function () {
                var elements = document.querySelectorAll('.ql-editor');
                if (elements.length) {
                    elements[0].id = this.props.name;
                }
            }
                .bind(this),
            200
        );
        const errorLabel = <div className="customErrorLabel" />;
        return (
            <React.Fragment>
                {this.props.type === 'textarea' ?
                    <div>
                        <label className="f_semiBold f_11">{this.props.name}
                            {this.props.requiredValue ? <span className="clr-red">*</span> : ''}
                        </label>
                        <ReactQuill value={this.props.text ? this.props.text : ""}
                            onChange={(data) => {
                                this.props.onChangeText(data, this.props.name)
                            }}
                            theme="snow"
                            modules={modules}
                            formats={formats}
                            className={this.props.noToolbar ? "no-toolbar" : ""}
                            ref="bodyInput"
                        />
                    </div> :
                    <Form.Input
                        required
                        name={this.props.name}
                        id={this.props.name}
                        label={this.props.label ? this.props.label : this.props.name}
                        value={this.props.text}
                        placeholder={this.props.placeholder ? this.props.placeholder : ""}
                        validations={{ matchRegexp: singleLineText }}
                        errorLabel={errorLabel}
                        validationErrors={{
                            matchRegexp: 'Max limit is 128. No space allowed in starting.',
                            isDefaultRequiredValue: `${this.props.name} is required`,
                        }}
                        onChange={(e) => {
                            this.props.onChangeText(e.target.value.trim(), this.props.name)
                        }}
                        instantValidation={this.props.instationValidation ? this.props.instationValidation : true}
                        style={this.props.style ? this.props.style : null}
                        autoFocus={this.props.autoFocus ? this.props.autoFocus : null}
                    />
                }
            </React.Fragment>
        );
    }
}

export default withFormsy(TextEditor);
